export class CategoriesInformation {
  public static DOCTORS_MEDICAL = { name: 'DOCTORS/MEDICAL', icon: 'ss-stethoscope' };
  public static PHARMACIES = { name: 'PHARMACIES', icon: 'ss-medicalcross' };
  public static IMPORTANT_NUMBERS = { name: 'IMPORTANT NUMBERS', icon: 'ss-rotaryphone' };
  public static ATM_CASH_MACHINE = { name: 'ATM/CASH MACHINE', icon: 'ss-eurosign' };
  public static TAXI = { name: 'TAXI', icon: 'ss-taxi' };
  public static PARKING = { name: 'PARKING', icon: 'ss-parking' };
  public static EMERGENCY_SERVICES = { name: 'EMERGENCY SERVICES', icon: 'ss-lifepreserver' };
  public static DENTIST = { name: 'DENTIST', icon: 'ss-tooth' };
  public static RELIGIOUS_SERVICES = { name: 'RELIGIOUS SERVICES', icon: 'ss-clock' };
  public static BIKE_HIRE = { name: 'BIKE HIRE', icon: 'ss-clock' };
  public static DEFIBRILLATORS = { name: 'DEFIBRILLATORS', icon: 'ss-clock' };
  public static FUNERAL = { name: 'FUNERAL', icon: 'ss-clock' };
}

const urlIcons = 'iconsImportantInformation';

export const getIcon = (item: any) => {
  if (item) {
    switch (item) {
      case CategoriesInformation.ATM_CASH_MACHINE.name:
        return `/${urlIcons}/atm.png`;
      case CategoriesInformation.BIKE_HIRE.name:
        return `/${urlIcons}/bike.png`;
      case CategoriesInformation.EMERGENCY_SERVICES.name:
      case CategoriesInformation.DEFIBRILLATORS.name:
        return `/${urlIcons}/defibrillator.png`;
      case CategoriesInformation.DENTIST.name:
        return `/${urlIcons}/dentist.png`;
      case CategoriesInformation.DOCTORS_MEDICAL.name:
        return `/${urlIcons}/doctors.png`;
      case CategoriesInformation.PARKING.name:
        return `/${urlIcons}/parking.png`;
      case CategoriesInformation.PHARMACIES.name:
        return `/${urlIcons}/pharmacy.png`;
      case CategoriesInformation.RELIGIOUS_SERVICES.name:
        return `/${urlIcons}/religious.png`;
      case CategoriesInformation.TAXI.name:
        return `/${urlIcons}/taxi.png`;
      case CategoriesInformation.IMPORTANT_NUMBERS.name:
        return `/${urlIcons}/info.png`;
      case CategoriesInformation.FUNERAL.name:
        return `/${urlIcons}/tombstone.png`;
    }
  } else {
    return `/${urlIcons}/info.png`;
  }
};

export const getColor = (item: any) => {
  if (item) {
    switch (item) {
      case CategoriesInformation.ATM_CASH_MACHINE.name:
        return '#0DC1C1';
      case CategoriesInformation.BIKE_HIRE.name:
        return '#8B09EE';
      case CategoriesInformation.DEFIBRILLATORS.name:
        return '#FF6666';
      case CategoriesInformation.DENTIST.name:
        return '#FFFFFF';
      case CategoriesInformation.DOCTORS_MEDICAL.name:
        return '#3891A6';
      case CategoriesInformation.PARKING.name:
        return '#0C88F5';
      case CategoriesInformation.PHARMACIES.name:
        return '#9963A3';
      case CategoriesInformation.RELIGIOUS_SERVICES.name:
        return '#C2BBF0';
      case CategoriesInformation.TAXI.name:
        return '#FFD130';
      case CategoriesInformation.EMERGENCY_SERVICES.name:
        return '#fd3b3a';
      case CategoriesInformation.FUNERAL.name:
        return '#fcffcf';
    }
  }
};
